import dayjs from "~/lib/dayjs";
import { NUMERIC_TYPES } from "./types";

const BLANK = "—";

// Never pass an exact decimal through binary floating point for presentation.
const formatDecimal = (value, currency = false) => {
  const match = /^(-?)(\d+)(?:\.(\d+))?$/.exec(String(value));
  if (!match) {
    return BLANK;
  }
  const [, sign, integer, fraction = ""] = match;
  const grouped = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  const decimals = currency ? fraction.padEnd(2, "0") : fraction;
  return `${sign}${currency ? "$" : ""}${grouped}${decimals ? `.${decimals}` : ""}`;
};

/** Format the server-authorized saved values, including archived selections. */
export const formatValue = (field, value) => {
  if (
    value == null ||
    value === "" ||
    (Array.isArray(value) && !value.length)
  ) {
    return BLANK;
  }
  const type = field.field_type;
  if (type === "boolean") {
    if (value === true) {
      return "Yes";
    }
    return value === false ? "No" : BLANK;
  }
  if (NUMERIC_TYPES.includes(type)) {
    const formatted = formatDecimal(value, type === "currency_usd");
    return formatted !== BLANK && type === "percentage"
      ? `${formatted}%`
      : formatted;
  }
  if (type === "date") {
    const date = dayjs(value, "YYYY-MM-DD", true);
    return date.isValid() ? date.format("ll") : BLANK;
  }
  if (type === "single_select" || type === "multi_select") {
    const selected = new Set(
      (Array.isArray(value) ? value : [value]).map(String),
    );
    return (
      (field.options || [])
        .filter((option) => selected.has(String(option.id)))
        .map((option) => option.label)
        .join(", ") || BLANK
    );
  }
  return typeof value === "string" ? value : BLANK;
};
